export const PPLX_CHOSEN_LOCALE_COOKIE = 'pplx.chosen-locale';
export const PPLX_LOSS_AVERSION_MODAL_STATUS = 'pplx.la-status';
export const PPLX_PREFERS_METRIC = 'pplx.prefers-metric';
export const PPLX_DEFAULT_SEARCH_SESSION_COOKIE = 'pplx.default-search-session';
export const PPLX_UTM_SOURCE_COOKIE = 'pplx.utm-source';
export const PPLX_DYNAMIC_COPY_COOKIE = 'pplx.pt';
export const PPLX_TASKS_SETTINGS_SEEN = 'pplx.tasks-settings-seen';
export const PPLX_FINANCE_UXR_PROMPT_IMPRESSIONS = 'pplx.finance-uxr-prompt-impressions';
export const PPLX_SHOW_MODERATED_CONTENT = 'pplx.show-moderated-content';
export const PPLX_PATENTS_TUTORIAL_DISMISSED = 'pplx.patents-tutorial-dismissed';
// https://developer.chrome.com/blog/cookie-max-age-expires
export const MAX_DAYS = 400;
export const ONE_MONTH_IN_DAYS = 30;
export const ONE_HOUR_IN_DAYS = 1 / 24;
export const TEN_MINUTES_IN_DAYS = 10 / (24 * 60);
//# sourceMappingURL=cookieConstants.js.map